import type { HiveModule } from '@/modules';

/** Placeholder until the module's phase builds it. */
export function ModulePage({ module }: { module: HiveModule }) {
  const Icon = module.icon;
  return (
    <div className="mx-auto w-full max-w-[860px] px-7 pt-14 pb-10">
      <p className="hud-label mb-3.5">Module</p>
      <h1 className="mb-4 flex items-center gap-3 font-display text-3xl font-black tracking-[0.04em] text-cyan uppercase text-shadow-glow-cyan">
        <Icon className="size-7 text-magenta" aria-hidden />
        {module.name}
      </h1>
      <p className="text-lg text-muted">{module.summary}.</p>
      <div className="cut-tr mt-8 bg-bg-2/85 p-6 shadow-[inset_0_0_0_1px_var(--color-line)]">
        <p className="font-mono text-sm text-yellow">
          Coming in Phase {module.phase}. See <code>docs/phases/</code> for the plan.
        </p>
      </div>
    </div>
  );
}
